var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListUnordered = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33335H17.5V5.00002H6.66667V3.33335ZM3.75 5.41669C3.05964 5.41669 2.5 4.85705 2.5 4.16669C2.5 3.47633 3.05964 2.91669 3.75 2.91669C4.44036 2.91669 5 3.47633 5 4.16669C5 4.85705 4.44036 5.41669 3.75 5.41669ZM3.75 11.25C3.05964 11.25 2.5 10.6904 2.5 10C2.5 9.30969 3.05964 8.75002 3.75 8.75002C4.44036 8.75002 5 9.30969 5 10C5 10.6904 4.44036 11.25 3.75 11.25ZM3.75 17C3.05964 17 2.5 16.4404 2.5 15.75C2.5 15.0597 3.05964 14.5 3.75 14.5C4.44036 14.5 5 15.0597 5 15.75C5 16.4404 4.44036 17 3.75 17ZM6.66667 9.16669H17.5V10.8334H6.66667V9.16669ZM6.66667 15H17.5V16.6667H6.66667V15Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListUnordered, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list-unordered.468ee9c4.svg";
export { ForwardRef as ReactComponent };